import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import ChartName from "../../Dashboard/Charts/ChartName";
import NoData from "../../Dashboard/Charts/NoData/NoData";
import { Dimmer, Loader } from "semantic-ui-react";
import { Icon } from "semantic-ui-react";
import ShareOfVoiceForProductAttributesChart from "../../Dashboard/Charts/ShareOfVoiceForProductAttributes/ShareOfVoiceForProductAttributesCharts";
import moment from "moment";
import { QuestionLists } from "../HomePage/Header/InsightsTabComponent";

const ProductAttributes = () => {
    const brandTopicObj = useSelector((state) => state.insightsRecommendationReducer.ownBrand);
    const competitorTopicObj = useSelector((state) => state.insightsRecommendationReducer.competitorsBrand);
    const topic1Data = useSelector((state) => state.insightsRecommendationReducer.chartData?.["product-attributes"]?.own);
    const topic1DataLoading = useSelector((state) => state.insightsRecommendationReducer.chartDataLoading?.["product-attributes"]?.own);
    const topic2Data = useSelector((state) => state.insightsRecommendationReducer.chartData["product-attributes"]?.competitor);
    const topic2DataLoading = useSelector((state) => state.insightsRecommendationReducer.chartDataLoading["product-attributes"]?.competitor);
    const currentPage = useSelector((state) => state.insightsRecommendationReducer.currentPage);

    let widgetContainerRef1 = useRef(null);
    let widgetContainerRef2 = useRef(null);
    const [graph_type1, changeGraphType1] = useState("pie");
    const [graph_type2, changeGraphType2] = useState("pie");

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    let range = moment().tz(tz).subtract(7, "days").format("DD-MM-YYYY") + ` to ` + moment().tz(tz).subtract(1, "days").format("DD-MM-YYYY");
    let question = QuestionLists.find((obj) => obj.questionTab === currentPage)?.question || "";

    const getProductAttributesChart = (data, loading, ref, topic, graph_type, changeGraphType) => {
        // console.log("firstdata", data);
        // let nodata = !data || (data && data.formatted_data && data.formatted_data.length === 0);
        let data2 = data?.data ? JSON.parse(JSON.stringify(data?.data?.sort((a, b) => a?.name?.localeCompare(b?.name))?.[0])) : null;
        let nodata = !data || (data && data?.nodata);

        let topicName = topic === "topic1" ? "Product attributes for own brand" : "Product attributes for competitor brand";
        let info =
            topic === "topic1"
                ? "This chart will show you the product attributes for your own brand"
                : "This chart will show you the product attributes for your competitor brand";

        return (
            <>
                <div className={`dashboard-widget-container ${brandTopicObj && competitorTopicObj ? "" : ""}`} ref={ref}>
                    <div className="dashboard-widget-container-header skiptranslate ocr__owncloud">
                        <ChartName name={topicName} info={info} chatGPT={true} />
                        {/* <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                            {!nodata && (
                                <div className="chart-type">
                                    <span onClick={() => changeGraphType("pie")} className={graph_type === "pie" ? "active-chart" : ""}>
                                        <Icon name="pie chart" />
                                    </span>
                                    <span onClick={() => changeGraphType("bar")} className={graph_type === "bar" ? "active-chart" : ""}>
                                        <Icon name="bar chart" />
                                    </span>
                                    <span onClick={() => changeGraphType("line")} className={graph_type === "line" ? "active-chart" : ""}>
                                        <Icon name="line chart" />
                                    </span>
                                </div>
                            )}
                        </div> */}
                    </div>
                    {loading ? (
                        <div className="no__data__block">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                    ) : !nodata ? (
                        <div className="dashboard-chart wordcloud-chart skiptranslate ">
                            <ShareOfVoiceForProductAttributesChart
                                data={data2}
                                currentChartType={"pie"}
                                showGridLines={true}
                                showLabel={false}
                                showLegend={true}
                                widgetContainerRef={ref}
                                // addContextMenuListener={this.addContextMenuListener}
                                // comparisionData={comparisionData}
                                // expandWidget={this.props.expandWidget}
                                insights__recommendation
                            />
                        </div>
                    ) : (
                        <>
                            <NoData classname="gpt__no__data" />
                        </>
                    )}
                </div>
            </>
        );
    };

    return (
        <>
            <div className={`ocr__wordcloud__wrapper column__flex`}>
                <div className="gptHeader">
                    <div className="top">
                        <div>{question} </div>
                    </div>
                    <div className="lower">{`From date: ${range}`}</div>
                </div>
                {brandTopicObj
                    ? getProductAttributesChart(
                          topic1Data,
                          topic1DataLoading,
                          widgetContainerRef1,
                          "topic1",
                          //   "Product attributes for own brand",
                          graph_type1,
                          changeGraphType1,
                      )
                    : null}
                {competitorTopicObj
                    ? getProductAttributesChart(
                          topic2Data,
                          topic2DataLoading,
                          widgetContainerRef2,
                          "topic2",

                          graph_type2,
                          changeGraphType2,
                      )
                    : null}
            </div>
        </>
    );
};

export default ProductAttributes;
